import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { func, string } from 'prop-types';

import Urls from 'mangools-commons/dist/constants/Urls';

import RouterService from 'services/RouterService';
import RoutePaths from 'constants/RoutePaths';

function MenuLeft(props) {
    return (
        <nav className="uk-flex uk-flex-middle">
            <ul className="mg-nav is-app uk-flex-inline">
                <li
                    className={classnames({
                        'uk-active': RouterService.isSame(props.currentRoute, RoutePaths.ROOT),
                    })}
                >
                    <Link to={RoutePaths.ROOT}>Search</Link>
                </li>
                <li>
                    <button onClick={props.onShowHistoryPanel} type="button">
                        History
                    </button>
                </li>
                <li>
                    <a
                        href={`${Urls.MANGOOLS_MCP_URL}?ref=header-app-sp`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        MCP server
                        <strong className="mg-label is-white is-xsmall font-10 mg-margin-l-5">NEW</strong>
                    </a>
                </li>
            </ul>
        </nav>
    );
}

MenuLeft.propTypes = {
    currentRoute: string.isRequired,
    onShowHistoryPanel: func.isRequired,
};

export default MenuLeft;
